import { Loader2 } from "lucide-react";

export const HuntProgress = ({ job }) => {
  if (!job) return null;
  const pct = Math.max(2, Math.min(100, job.progress || 0));
  return (
    <div className="mt-2 rounded-lg border border-ism-teal/20 bg-ism-teal/5 px-3 py-2" data-testid="hunt-progress">
      <div className="flex items-center justify-between text-[11px] mb-1.5">
        <span className="text-ism-teal flex items-center gap-1.5">
          <Loader2 className="h-3 w-3 animate-spin" />
          <span data-testid="hunt-progress-stage">{job.stage || "Starting hunt"}</span>
        </span>
        <span className="text-gray-400 font-mono" data-testid="hunt-progress-pct">{pct}%</span>
      </div>
      <div className="h-1 rounded-full bg-white/10 overflow-hidden">
        <div className="h-full bg-ism-teal rounded-full transition-[width] duration-700 ease-out" style={{ width: `${pct}%` }} />
      </div>
      <p className="text-[10px] text-gray-500 mt-1">Runs in the background — registries, people data and the AI judge can take up to ~90s.</p>
    </div>
  );
};
